import React from "react";

export function DescriptionFormatter(cellContent, row){
    return (
        <>
            {row.description}
        </>
    )
}